module.exports = __webpack_public_path__ + "img/aa_pic_logo_2@_x2.5c4e9efd.png";